export const header = {
  uk: {
    logo: "EN",
    image: "uk",
    menu: [
      { to: "/", label: "ГОЛОВНА" },
      { to: "/about", label: "ПРО КУРС" },
      { to: "/myprogress", label: "ПРОГРЕС" },
      { to: "/vocabulary", label: "СЛОВНИК" },
      { to: "/grammar", label: "ГРАМАТИКА" },
      { to: "/reading", label: "ЧИТАННЯ" },
      { to: "/listening", label: "АУДІО" },
      { to: "/speaking", label: "ГОВОРІННЯ" },
    ],
    guest: "ГОСТЬОВИЙ РЕЖИМ. УВІЙДІТЬ ДЛЯ ДОСТУПУ"
  },
  en: {
    logo: "UK",
    image: "en",
    menu: [
      { to: "/", label: "HOME" },
      { to: "/about", label: "ABOUT" },
      { to: "/myprogress", label: "PROGRESS" },
      { to: "/vocabulary", label: "VOCABULARY" },
      { to: "/grammar", label: "GRAMMAR" },
      { to: "/reading", label: "READING" },
      { to: "/listening", label: "LISTENING" },
      { to: "/speaking", label: "SPEAKING" },
    ],
    guest: "YOU ARE IN GUEST MODE. PLEASE LOG IN"
  },
};
